import React from "react";
import { Box, Typography, Card, Divider, Button, CircularProgress  } from "@mui/material";

export default function FeedbackSummary({
   questions, 
   answers = [], 
   feedback = [],
   onSemanticEvaluate,
   onLangchainEvaluate,   
   loadingSemanticEval,
   loadingLangchainEval,
   onBack,   // ✅ add this
   }) {
  console.log("Rendering FeedbackSummary:", feedback);

  return (
    <Box>
      <Button
        variant="outlined"
        color="primary"
        onClick={onBack}
        sx={{ mb: 2 }}
      >
        ← Back to Learning Assistant
      </Button>

      <Typography variant="h5" gutterBottom>        
        Quiz Feedback Summary
      </Typography>

      {questions.map((q, idx) => {
        //const fb = feedback?.[idx] || {};
        //const userAnswer = answers?.[idx] ?? fb?.answer ?? "Not answered";
        const fb = feedback[idx]; // now guaranteed to exist
        const userAnswer = answers[idx] || "";   // guaranteed to exist
        console.log(`Feedback for Q${idx + 1}:`, fb);

        return (
          <Card
            key={idx}
            variant="outlined"
            sx={{
              p: 2,
              mb: 2,
              backgroundColor: "#f5f5f5",
              borderLeft:
                fb.grade === "Correct"
                  ? "4px solid green"
                  : fb.grade === "Incorrect"
                  ? "4px solid red"
                  : "4px solid #ccc",
            }}
          >
            <Typography variant="subtitle1">
              <strong>Q{idx + 1}:</strong> {q.question}
            </Typography>

            <Typography variant="body2">
              <strong>Your Answer:</strong> {userAnswer || "Not answered"}
            </Typography>

            {fb?.grade ? (
              <>
                <Typography variant="body2">
                  <strong>Grade:</strong>{" "}
                  <span style={{ color: fb.grade === "Correct" ? "green" : "red" }}>
                    {fb.grade}
                  </span>
                </Typography>

                <Typography variant="body2">
                  <strong>Feedback:</strong> {fb.feedback || "No feedback provided."}
                </Typography>

                {fb?.expected_answer && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="body2">
                      <strong>Expected Answer:</strong>{" "}
                      <span style={{ fontStyle: "italic", color: "#1976d2" }}>
                        {fb.expected_answer}
                      </span>
                    </Typography>
                  </>
                )}
              </>
            ) : (
              <Typography variant="body2">No feedback available yet.</Typography>
            )}
          </Card>
        );
      })}
       {/* ✅ Evaluate button */}
      {/* <Box sx={{ textAlign: "center", mt: 3 }}>
        <Button
          // variant="contained"
          variant="outlined"
          color="primary"
          onClick={onSemanticEvaluate} // ✅ must be a function
          disabled={loadingSemanticEval}
        >
          Evaluate by Semantic Similarity
        </Button>
         {loadingSemanticEval && <CircularProgress size={18} />}
        <Button
          //variant="contained"
          variant="outlined"
          color="primary"
          onClick={onLangchainEvaluate} // ✅ must be a function
          disabled={loadingLangchainEval}
        >
          Evaluate by Langchain
        </Button>
         {loadingLangchainEval && <CircularProgress size={18} />}
      </Box> */}
    </Box>
  );
}
